/**
 * Data layer for `publisher-dashboard-separate-persona-with-partner`. Thin typed fetch wrappers over /api/v1/publisher-dashboard-separate-persona-with-partner.
 * Raw `fetch()` is confined to this file per the dash contract.
 */

export interface PublisherDashboardSeparatePersonaWithPartnerRow {
	id: string;
	tenant_id: string;
	created_at: number;
	updated_at: number;
	[key: string]: unknown;
}

export interface ListPublisherDashboardSeparatePersonaWithPartnerResponse {
	count: number;
	items: PublisherDashboardSeparatePersonaWithPartnerRow[];
}

export interface CreatePublisherDashboardSeparatePersonaWithPartnerBody {
	[key: string]: unknown;
}

const BASE = "/api/v1/publisher-dashboard-separate-persona-with-partner";

async function parseOrThrow<T>(res: Response): Promise<T> {
	const text = await res.text();
	let data: unknown = null;
	if (text) {
		try {
			data = JSON.parse(text);
		} catch {
			data = text;
		}
	}
	if (!res.ok) {
		const msg =
			data &&
			typeof data === "object" &&
			data !== null &&
			"error" in data &&
			typeof (data as { error: unknown }).error === "string"
				? (data as { error: string }).error
				: `HTTP ${res.status}`;
		throw new Error(msg);
	}
	return data as T;
}

export async function list(): Promise<ListPublisherDashboardSeparatePersonaWithPartnerResponse> {
	const res = await fetch(BASE, {
		method: "GET",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<ListPublisherDashboardSeparatePersonaWithPartnerResponse>(res);
}

export async function create(body: CreatePublisherDashboardSeparatePersonaWithPartnerBody): Promise<PublisherDashboardSeparatePersonaWithPartnerRow> {
	const res = await fetch(BASE, {
		method: "POST",
		credentials: "include",
		headers: {
			accept: "application/json",
			"content-type": "application/json",
		},
		body: JSON.stringify(body ?? {}),
	});
	return parseOrThrow<PublisherDashboardSeparatePersonaWithPartnerRow>(res);
}

export async function remove(id: string): Promise<{ removed: boolean }> {
	const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
		method: "DELETE",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<{ removed: boolean }>(res);
}

export const publisherDashboardSeparatePersonaWithPartnerQueryKeys = {
	all: ["publisher-dashboard-separate-persona-with-partner"] as const,
	list: () => [...publisherDashboardSeparatePersonaWithPartnerQueryKeys.all] as const,
	detail: (id: string) => [...publisherDashboardSeparatePersonaWithPartnerQueryKeys.all, id] as const,
};
